import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import { SELECTED_USER_PROPTYPE } from 'common/constants/commonPropTypes';
import Avatar from 'common/components/Avatar';
import { EditUserContext, SelectedUsersContext } from 'pages/UserPage/context';

const UserCard = ({ user, multiSelectView }) => {
  const { setEditUser } = useContext(EditUserContext);
  const { selectedUsers, setSelectedUsers } = useContext(SelectedUsersContext);
  const isSelected = Array.isArray(selectedUsers) && selectedUsers.includes(user.userId);
  const handleSelectUser = () => {
    if (multiSelectView) {
      const newSelectedUsers = isSelected
        ? selectedUsers.filter(userId => userId !== user.userId)
        : [...selectedUsers, user.userId];
      setSelectedUsers(newSelectedUsers);
      if (newSelectedUsers.length === 0) {
        setEditUser(false);
      }
    } else {
      setSelectedUsers([user.userId]);
      setEditUser(false);
    }
  };
  return (
    <div
      onClick={handleSelectUser}
      role="button"
      style={{
        alignItems: 'center',
        background: '#FFFFFF',
        border: `1px solid ${isSelected ? '#42a5f5' : 'transparent'}`,
        borderRadius: '5px',
        cursor: 'pointer',
        display: 'flex',
        marginBottom: '10px',
        padding: '10px 23px',
      }}
    >
      <div style={{ alignItems: 'center', display: 'flex', height: '34px', justifyContent: 'center', width: '34px' }}>
        {multiSelectView ? (
          <Checkbox checked={isSelected} onChange={handleSelectUser} />
        ) : (
          <Avatar name={user.name} />
        )}
      </div>
      <div style={{ marginLeft: '15px' }}>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 'normal',
            lineHeight: '24px',
            textTransform: 'capitalize',
          }}
        >
          {' '}
          {user.name}
        </div>
        <div
          style={{
            color: '#999999',
            fontSize: '13px',
            height: '18px',
            lineHeight: '140%',
          }}
        >
          {user.phone}
        </div>
      </div>
    </div>
  );
};
UserCard.propTypes = {
  user: SELECTED_USER_PROPTYPE.isRequired,
  multiSelectView: PropTypes.bool,
};
UserCard.defaultProps = { multiSelectView: false };

export default UserCard;
